import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import {
  HStack,
  Image,
  InputGroup,
  InputLeftAddon,
  PinInput,
  PinInputField,
  useDisclosure,
} from "@chakra-ui/react";
import "./ModalBox.css";
// import OtpInput from "otp-input-react";
import indianFlagImage from "../../images/IndianFlag.png";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Box,
  Text,
  Input,
  Flex,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import {
  fetchUserProfileAsync,
  loginUserAsync,
  otpVerifyUserAsync,
} from "../../features/User/UserSlice";
import { toast, Toaster } from "react-hot-toast";

function ModalBox() {
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [mobileNo, setMobileNo] = useState();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  const dispatch = useDispatch();
  const handleChange = (index, value) => {
    const newOtp = otp.slice(0, index) + value + otp.slice(index + 1);
    setOtp(newOtp);
  };

  const onOTPVerify = (mobile, otp) => {
    console.log(mobile, otp);
    dispatch(otpVerifyUserAsync({ mobile, otp })).then((res) => {
      if (res?.payload.status === 1) {
        toast.success(res?.payload?.message);
        setTimeout(() => {
          dispatch(fetchUserProfileAsync());
        }, 1000);
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };

  const sendOtp = async () => {
    let data = { mobileNo };
    if (mobileNo.length >= 10) {
      dispatch(loginUserAsync(data))
        .then((response) => {
          if (response?.payload?.status === 1) {
            toast.success(response?.payload?.message);
          } else {
            toast.error(response?.payload?.message);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      toast.error("Please enter a valid phone number.");
    }
  };
  const handleContinue = async () => {
    try {
      if (step === 1) {
        if (mobileNo) {
          await sendOtp();
          setStep((prevStep) => prevStep + 1);
        } else {
          toast.error("Please enter a valid phone number.");
        }
      } else if (step === 2) {
        onOTPVerify(mobileNo, otp);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleStepClick = async (stepNumber) => {
    setStep(stepNumber);
  };

  return (
    <>
      <Button
        onClick={onOpen}
        id="login_btn"
        variant="outline"
        w={["50px", "50px", "70px", "111px"]}
        h={["30px", "40px"]}
        fontSize={["10px", "14px", "16px"]}
        mr={["10px", "10px", "10px", "10px", "0px"]}
      >
        LOGIN
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay
          style={{
            backdropFilter: "blur(2px)", // Apply the backdrop blur effect
          }}
        />

        <ModalContent
          width={["90%", "700px"]}
          height={["auto", "550px"]}
          borderRadius="28px"
          background="#fff"
          padding={[2, 10]}
        >
          <ModalCloseButton
            backgroundColor="#8E8E8E"
            borderRadius="50%"
            color="white"
          />
          <ModalBody>
            {/* Progress Bar */}
            <Flex
              width={["100%", "80%", "60%", "320px"]}
              maxW="100%"
              height="12px"
              gap="10px"
              borderRadius="50px"
              mt={{ base: 4, md: 6 }}
              mx="auto"
            >
              <Box
                onClick={() => handleStepClick(1)}
                flex="1"
                height="100%"
                borderRadius="50px"
                background="#52771A"
                cursor="pointer"
              />
              <Box
                onClick={() => handleStepClick(2)}
                flex="1"
                height="100%"
                borderRadius="50px"
                background={step >= 2 ? "#52771A" : "#F3FFE1"}
                cursor="pointer"
              />
            </Flex>

            {/* Step Text */}
            <Text
              fontSize={["24px", "28px", "32px"]}
              lineHeight="1.3"
              fontWeight="700"
              mt="4"
            >
              {step === 1 && "Login"}
              {step === 2 && "Step 2"}
            </Text>
            {step === 1 && (
              <Text id="normal_text">Please Enter Mobile Number </Text>
            )}
            {/* Step Content */}
            {step === 1 && (
              <>
                {step === 1 && <Toaster toastOptions={{ duration: 4000 }} />}
                <Text
                  color="#404040"
                  fontFamily="Inter"
                  fontSize="16px"
                  fontStyle="normal"
                  fontWeight="500"
                  lineHeight="normal"
                  mt="4"
                >
                  Mobile No
                </Text>
                <InputGroup>
                  <InputLeftAddon>
                    <Image
                      src={indianFlagImage}
                      borderRadius="full"
                      boxSize="25px"
                      alt="+91"
                    />
                  </InputLeftAddon>
                  <Input
                    type="number"
                    placeholder="phone number"
                    value={mobileNo}
                    onChange={(event) => setMobileNo(event.target.value)}
                    fontSize={["14px", "16px"]}
                    py={[2, 3]}
                  />
                </InputGroup>
              </>
            )}
            {step === 2 && (
              <>{step === 2 && <Toaster toastOptions={{ duration: 4000 }} />}</>
            )}
            {step === 2 && (
              <>
                {step === 2 && <Toaster toastOptions={{ duration: 4000 }} />}
                <Text
                  color="#404040"
                  fontFamily="Inter"
                  fontSize="16px"
                  fontStyle="normal"
                  fontWeight="500"
                  lineHeight="normal"
                  mt="4"
                >
                  Enter 4 Digit OTP
                </Text>
                <HStack mt={5} spacing={[2, 3, 4]} justify="center">
                  <PinInput>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <PinInputField
                        key={index}
                        value={otp[index] || ""}
                        onChange={(e) => handleChange(index, e.target.value)}
                        fontSize={["18px", "24px"]}
                        w={["40px", "50px"]}
                        h={["40px", "50px"]}
                      />
                    ))}
                  </PinInput>
                </HStack>
              </>
            )}
            <Button
              w="100%"
              mt="6"
              fontSize={["14px", "16px"]}
              py={6}
              bg="#52771A"
              borderRadius="14px"
              color="#f3ffe1"
              onClick={handleContinue}
            >
              {loading && <CgSpinner size={20} className="animate-spin mr-2" />}
              <span>{step === 2 ? "Verify OTP" : "Send OTP"}</span>
            </Button>
            {step === 1 && (
              <Box mt={6} textAlign="center">
                <Text mb={2}>or</Text>
                <Box display="inline-block" minW="250px" mx="auto">
                  <GoogleLogin
                    onSuccess={(credentialResponse) => {
                      const token = credentialResponse.credential;
                      const userInfo = jwtDecode(token);
                      console.log("Google user info:", userInfo);

                      dispatch(
                        loginUserAsync({ token, method: "google" })
                      ).then((res) => {
                        if (res?.payload?.status === 1) {
                          toast.success(res?.payload?.message);
                          setTimeout(() => {
                            dispatch(fetchUserProfileAsync());
                            onClose();
                          }, 1000);
                        } else {
                          toast.error(
                            res?.payload?.message || "Google login failed"
                          );
                        }
                      });
                    }}
                    onError={() => {
                      toast.error("Google Login Failed");
                    }}
                  />
                </Box>
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalBox;
// completed
